<div class="fill-height d-flex justify-content-center">
  <!-- ============== spinner ============== -->
  <div *ngIf="isLoading" class="d-flex p-3 h-100 align-items-center justify-content-center">
    <mat-spinner class="zx-big-icon-size"></mat-spinner>
  </div>
  <!-- // ============== spinner ============== -->

  <!-- ============== CHOOSE WHAT TO SHOW IN P.Q. ============== -->
  <div *ngIf="!isLoading && !isQueShowen" class="w-100 flex-grow-1 p-3">
    <!-- CHOOSE service -->
    <h4 class="pt-5 px-4">
      {{ "s-screen.select.title-service" | translate }}
    </h4>
    <div class="pt-2 px-4">
      <mat-button-toggle-group name="printingService" [(ngModel)]="printingService" (change)="resetPapers()">
        <mat-button-toggle value="plotter">
          {{ "choose-system.plotter" | translate }}
        </mat-button-toggle>
        <mat-button-toggle value="express">
          {{ "choose-system.express" | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <!-- CHOOSE branches -->
    <h4 class="pt-5 px-4">
      {{ "s-screen.select.title-branch" | translate }}
    </h4>
    <form class="d-flex flex-column pt-2 px-4" [formGroup]="form">
      <!-- branches -->
      <mat-form-field>
        <mat-label>
          {{ "s-screen.select.title-branch" | translate }}
        </mat-label>
        <mat-select formControlName="branches" multiple>
          <div *ngFor="let branch of branches">
            <mat-option *ngIf="branch.plotter && printingService === 'plotter'" [value]="branch.name">
              {{ "choose-branch.naming.plotter." + branch.name | translate }}
            </mat-option>
            <mat-option *ngIf="branch.express && printingService === 'express'" [value]="branch.name">
              {{ "choose-branch.naming.express." + branch.name | translate }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
  <!-- // ============== CHOOSE WHAT TO SHOW IN P.Q. ============== -->

  <!-- ============== CHOOSE WHAT TO SHOW IN P.Q. - btn ============== -->
  <div *ngIf="!isQueShowen" class="d-flex p-5">
    <button class="w-100 rounded-pill zx-text-white" mat-raised-button type="button" color="primary"
      [disabled]="form?.get('branches')?.value?.length < 1 || form?.get('branches')?.value?.length > 2"
      (click)="updateSelectedBranchesAndShowQueue()">
      {{ "s-screen.show.que" | translate }}
    </button>
  </div>
  <!-- ============== CHOOSE WHAT TO SHOW IN P.Q. - btn ============== -->


















  <!-- ============== PRINTING QUEUE ============== -->
  <div *ngIf="!isLoading && isQueShowen" class="w-100 w-100 d-flex position-relative">
    <div class="position-relative w-100 h-100 bottom-0 zx-z-index-2">
      <div class="w-100 d-flex flex-column h-100">
        <article *ngFor="let branch of selectedBranches; let i = index" class="w-100 d-flex flex-column"
          [class.zx-branch-dubble-printer-top]="selectedBranches.length > 1 && i === 0"
          [class.zx-branch-dubble-printer-bottom]="selectedBranches.length > 1 && i === 1"
          [class.vh-100]="selectedBranches.length === 1" [class.zx-vh-50]="selectedBranches.length > 1">
          <div class="zx-que-header position-relative" [class.zx-rounded-top-5]="selectedBranches.length > 1">
            <h1 class="title-que-trans w-100 d-flex align-items-center justify-content-center p-0 m-0 text-center">
              <span *ngIf="printingService === 'plotter'">
                {{ "choose-branch.naming.plotter." + branch.name | translate }}
              </span>
              <div class="d-flex align-items-center gap-4"
                *ngIf="printingService === 'express' && isImagesBranch(selectedBranches[i])">
                <div class="animation-con" id="animationContainerPics">
                </div>
                <b>
                  {{ "choose-branch.naming.express." + branch.name | translate }}
                </b>
                <div class="animation-con"></div>
              </div>
              <div class="d-flex align-items-center gap-4"
                *ngIf="printingService === 'express' && !isImagesBranch(selectedBranches[i])">
                <div class="animation-con" id="animationContainerDocs">
                </div>
                <b>
                  {{ "choose-branch.naming.express." + branch.name | translate }}
                </b>
                <div class="animation-con"></div>
              </div>
            </h1>
          </div>
          <div class="d-flex flex-grow-1 p-0" style="max-width: 100%;"
            [class.zx-rounded-bottom-5]="selectedBranches.length > 1">

            <!-- ================== existing order ================== -->
            <div class="col-5 d-flex flex-column justify-content-between align-items-center px-0 py-5">
              <!-- title -->
              <h2 class="text-white">
                {{ "s-screen.title-sub.new-order" | translate }}
              </h2>
              <!-- // title -->
              <!-- qr -->
              <div class="zx-que-qr-con">
                <img class="w-100 h-100 object-fit-cover"
                  [src]="'http://api.qrserver.com/v1/create-qr-code/?data=https://print.eazix.io/qr/' + printingService + '/' + ((printingService === 'express') ? branch.express?.serial_name : branch.plotter?.serial_name) + '&size=250x250&color=4D4D4D'">
              </div>
              <!-- // qr -->
              <span class="spacer"></span>
              <div class="d-flex justify-content-center align-items-center gap-2">
                <span class="zx-que-small-line"></span>
                <span class="zx-que-text-small zx-text-white pt-2">
                  {{ "s-screen.title-sub.or" | translate }}
                </span>
                <span class="zx-que-small-line"></span>
              </div>
              <span class="spacer"></span>
              <!-- or: url -->
              <div class="d-flex flex-column align-items-center gap-3 text-white">

                <b class="zx-que-text-medium">
                  print.eazix.io
                </b>

                <span class="zx-que-text-small">
                  {{ "s-screen.title-sub.go-to-url" | translate }}
                </span>
              </div>
              <!-- // or: url -->
            </div>
            <!-- // ================== existing order ================== -->

            <!-- ================== new order ================== -->
            <div class="col-7 d-flex flex-column align-items-center px-0 py-5">
              <h2 class="text-white">
                <span *ngIf="printingService === 'plotter'">
                  {{ "s-screen.title-sub.view-que" | translate }}
                </span>
                <span *ngIf="printingService === 'express'">
                  {{ "s-screen.title-sub.existing-order" | translate }}
                </span>
              </h2>

              <!-- ---------==================--------- QUE AREA - [express] ---------==================--------- -->
              <div class="zx-que-que-con" [class.zx-que-que-con-dubble-branch]="selectedBranches.length > 1"
                *ngIf="printingService === 'express'">

                <!-- -=-=- STATUS: Available -=-=- -->
                <article *ngIf="!isExpressError(i) &&
                                !branch.express?.queue?.printerQueue?.length && !branch.express?.queue?.queue?.length
                                && isVeryUpdated() && !branch.express?.properties?.close
                                && !branch.express?.reboot?.in_progress"
                  class="justify-content-center">
                  <div class="d-flex flex-column align-items-center justify-content-center h-100 w-100">
                    <span class="zx-que-text-small pt-5">
                      {{ "s-screen.title.next-code-is" | translate }}
                    </span>
                    <span class="zx-que-code">
                      {{
                      printingCode(
                      branch.express.unique,
                      branch.express.properties.code
                      )
                      }}
                    </span>
                  </div>
                </article>
                <!-- // -=-=- STATUS: Available -=-=- -->

                <!-- -=-=- STATUS: close -=-=- -->
                <article *ngIf="branch.express?.properties?.close" class="justify-content-center">
                  <div class="d-flex flex-column align-items-center justify-content-center h-100 w-100">
                    <b class="zx-que-text-big pb-3">
                      {{ "su-management.branches_close-true" | translate }}
                    </b>
                    <span class="zx-que-text-medium text-center px-5">
                      {{ branch.express.properties.close_msg ? branch.express.properties.close_msg : "" }} </span>
                  </div>
                </article>
                <!-- // -=-=- STATUS: close -=-=- -->

                <!-- -=-=- STATUS: Reboot -=-=- -->
                <article *ngIf="branch.express?.reboot?.in_progress && !branch.express?.properties?.close"
                  class="justify-content-center">
                  <div class="d-flex flex-column align-items-center justify-content-center h-100 w-100 px-5">
                    <b *ngIf="branch.express?.reboot?.reboot_needed" class="zx-que-text-big text-center">
                      {{ "su-management.station_reboot-needed" | translate }}
                    </b>
                    <b *ngIf="!branch.express?.reboot?.reboot_needed" class="zx-que-text-big text-center">
                      {{ "su-management.station_reboot-in-progress" | translate }}
                    </b>
                    <span class="zx-que-text-small text-center pt-4">
                      {{ "su-management.station_reboot.sub" | translate }}
                    </span>
                  </div>
                </article>
                <!-- // -=-=- STATUS: Reboot -=-=- -->

                <!-- -=-=- STATUS: Printing Job -=-=- -->
                <article *ngIf="!isExpressError(i) &&
                          (branch.express?.queue?.printerQueue?.length || branch.express?.queue?.queue?.length) &&
                          isVeryUpdated() && !branch.express?.properties?.close
                          && !branch.express?.reboot?.in_progress" class="justify-content-center">
                  <div class="d-flex flex-column align-items-center justify-content-center h-100 w-100 px-5">
                    <span class="zx-que-text-huge text-center">
                      <span
                        *ngIf="branch.express?.queue?.printerQueue[0]?.user || branch.express?.queue?.queue[0]?.user">
                        <span>
                          {{ (branch.express?.queue?.printerQueue[0]?.user ?? branch.express?.queue?.queue[0]?.user) |
                          slice:0:9 }}
                        </span>
                        <span
                          *ngIf="branch.express?.queue?.printerQueue[0]?.user?.length > 9 || branch.express?.queue?.queue[0]?.user.length > 9">
                          ...
                        </span>
                      </span>
                      <span>, </span>
                    </span>
                    <b class="zx-que-text-huge text-center">
                      {{ "s-screen.status-title.printing-now" | translate }}
                    </b>
                    <span class="zx-que-text-small text-center pt-4">
                      {{ "s-screen.status-title.printing-now.sub" | translate }}
                    </span>
                  </div>
                </article>
                <!-- // -=-=- STATUS: Printing Job -=-=- -->

                <!-- -=-=- STATUS: Error and Offline -=-=- -->
                <article *ngIf="(isExpressError(i) ||
                               !isVeryUpdated()) && !branch.express?.properties?.close
                               && !branch.express?.reboot?.in_progress" class="justify-content-center">
                  <div class="d-flex flex-column align-items-center justify-content-center h-100 w-100 px-5">
                    <b *ngIf="!isVeryUpdated()" class="zx-que-text-tiny text-center text-red">
                      {{ "s-screen.status-title.error.phisical" | translate }}
                    </b>
                    <b *ngIf="isVeryUpdated() && branch.express?.status?.status_code_exp === 'Out of paper'" class="zx-que-text-medium text-center text-red">
                      {{ "s-screen.status-title.error.out-of-paper" | translate }}
                    </b>
                    <b *ngIf="isVeryUpdated() && branch.express?.status?.status_code_exp !== 'Out of paper'" class="zx-que-text-medium text-center text-red">
                      {{ "s-screen.status-title.error.offline" | translate }}
                    </b>
                    <b class="zx-que-text-big text-center py-5">
                      {{ "s-screen.status-title.error.sub" | translate }}
                    </b>
                    <b class="zx-que-text-tiny text-center">
                      {{ "s-screen.status-title.error.sub-phone" | translate }}
                    </b>
                    <div class="d-flex w-100 justify-content-center align-items-center gap-2 py-2">
                      <span class="zx-que-text-big zx-que-whatsup-text">
                        {{ "eazix.phone" | translate }}
                      </span>
                      <div class="zx-que-whatsup-logo-con">
                        <img src="assets/images/whatsup-logo.svg" class="zx-que-whatsup-logo">
                      </div>
                    </div>
                    <b class="zx-que-text-medium text-center">
                      {{ "s-screen.status-title.error.sub-phone.sub" | translate }}
                    </b>
                  </div>
                </article>
                <!-- // -=-=- STATUS: Error and Offline -=-=- -->
              </div>
              <!-- // ---------==================--------- QUE AREA - [express] ---------==================--------- -->

              <!-- ---------==================--------- QUE AREA - [plotter] ---------==================--------- -->
              <div class="zx-que-que-con" *ngIf="printingService === 'plotter'">

                <!-- -=-=- STATUS: close -=-=- -->
                <article *ngIf="branch.plotter.close" class="justify-content-center">
                  <div class="d-flex flex-column align-items-center justify-content-center h-100 w-100">
                    <b class="zx-que-text-tiny-tiny pb-3">
                      {{ "su-management.branches_close-true" | translate }}
                    </b>
                    <span class="zx-que-text-big text-center px-5">
                      {{branch.plotter.close_msg ? branch.plotter.close_msg : "" }} </span>
                  </div>
                </article>
                <!-- // -=-=- STATUS: close -=-=- -->

                <!-- -=-=- STATUS: OK! -=-=- -->
                <article *ngIf="!branch.plotter.close" class="justify-content-center h-100">

                  <!-- == QUEUE header == -->
                  <div class="zx-que-que-header-con zx-que-min-h-order d-flex row">

                    <!-- place -->
                    <div class="col-3 p-0 h-100 d-flex align-items-center justify-content-center">
                      <b class="zx-que-text-tiny-tiny text-white">
                        {{ "s-screen.plotter-que.title.place" | translate }}
                      </b>
                    </div>
                    <!-- // place -->

                    <!-- username -->
                    <div class="col-3 p-0 h-100 d-flex align-items-center justify-content-center">
                      <b class="zx-que-text-tiny-tiny text-white">
                        {{ "s-screen.plotter-que.title.username" | translate }}
                      </b>
                    </div>
                    <!-- // username -->

                    <!-- empty -->
                    <div class="col-3 p-0 h-100 d-flex"></div>
                    <!-- // empty -->

                    <!-- status -->
                    <div class="col-3 p-0 h-100 d-flex align-items-center justify-content-center">
                      <b class="zx-que-text-tiny-tiny text-white">
                        {{ "s-screen.plotter-que.title.status" | translate }}
                      </b>
                    </div>
                    <!-- status -->

                  </div>
                  <!-- // == QUEUE header == -->

                  <!-- == QUEUE content == -->
                  <div class="d-flex w-100 flex-grow-1 flex-shrink-1 position-relative">
                    <div id="scrollContainer" class="d-flex w-100 flex-column h-100 overflow-auto position-absolute"
                      style="max-height: 100%;">
                      <!-- ----- printerQueue orders ----- -->
                      <section
                        *ngIf="branch.plotter?.printers[0]?.printerQueue && branch.plotter?.printers[0]?.printerQueue?.length > 0"
                        class="w-100 d-flex flex-column p-0 m-0">
                        <div *ngFor="let order of branch.plotter?.printers[0]?.printerQueue; let i = index"
                          class="zx-que-order zx-que-min-h-order w-100 d-flex row p-0 m-0"
                          [class.zx-que-order-printing]="i === 0">

                          <!-- place -->
                          <div class="col-3 p-0 h-100 d-flex align-items-center justify-content-center">
                            <!-- 1st order -->
                            <div *ngIf="i === 0" class="d-flex">
                              <b class="zx-que-text-tiny-tiny text-green">
                                {{ "s-screen.plotter-que.title.printing" | translate }}
                              </b>
                            </div>
                            <!-- // 1st order -->
                            <!-- 2nd + orders -->
                            <div *ngIf="i > 0" class="d-flex">
                              <span class="zx-text-big d-flex align-items-center">
                                {{ i + 1 }}
                              </span>
                            </div>
                            <!-- // 2nd + orders -->
                          </div>
                          <!-- // place -->

                          <!-- username -->
                          <div class="col-3 p-0 h-100 d-flex align-items-center justify-content-center">
                            <b *ngIf="order.user" class="zx-que-text-tiny-tiny" [class.text-green]="i === 0">
                              <span>
                                {{ order.user | slice:0:9 }}
                              </span>
                              <span *ngIf="order.user?.length > 9">
                                ...
                              </span>
                            </b>
                          </div>
                          <!-- // username -->

                          <!-- empty -->
                          <div class="col-3 p-0 h-100"></div>
                          <!-- // empty -->

                          <!-- status -->
                          <div class="col-3 p-0 h-100 d-flex align-items-center justify-content-center">
                            <!-- 1st order -->
                            <div *ngIf="i === 0" class="d-flex align-items-center gap-2">
                              <span class="zx-que-text-tiny-tiny text-green">
                                {{ "s-screen.plotter-que.title.printing" | translate }}
                              </span>
                              <span
                                class="zx-text-big d-flex flex-row-reverse align-items-center px-2 py-1 rounded-pill zx-bg-gray-v-light-opacity">
                                <span>
                                  {{ order.currentImage }}
                                </span>
                                <span>/</span>
                                <span>
                                  {{ order.totalOrderLength }}
                                </span>
                              </span>
                            </div>
                            <!-- // 1st order -->
                            <!-- 2nd + orders -->
                            <div *ngIf="i > 0" class="d-flex">
                              <span class="zx-text-big">
                                <span>
                                  {{ getOrderTimeEstimation(branch, order, i, true) }}
                                </span>
                                <span>
                                  {{ "s-screen.minutes.short" | translate }}
                                </span>
                              </span>
                            </div>
                            <!-- // 2nd + orders -->
                          </div>
                          <!-- status -->

                        </div>
                      </section>
                      <!-- // ----- printerQueue orders ----- -->

                      <!-- ----- queue orders ----- -->
                      <section
                        *ngIf="branch.plotter?.printers[0]?.queue && branch.plotter?.printers[0]?.queue?.length > 0"
                        class="w-100 d-flex flex-column p-0 m-0">
                        <div *ngFor="let order of branch.plotter?.printers[0]?.queue; let i = index"
                          class="zx-que-order zx-que-min-h-order w-100 d-flex row p-0 m-0"
                          [class.zx-que-order-odd]="branch.plotter?.printers[0]?.printerQueue.length % 2 !== 0">

                          <!-- place -->
                          <div class="col-3 p-0 h-100 d-flex align-items-center justify-content-center">
                            <span class="zx-que-text-tiny-tiny">
                              {{ i + 1 + (branch.plotter?.printers[0]?.printerQueue?.length ?
                              branch.plotter?.printers[0]?.printerQueue?.length : 0) }}
                            </span>
                          </div>
                          <!-- // place -->

                          <!-- username -->
                          <div class="col-3 p-0 h-100 d-flex align-items-center justify-content-center">
                            <span *ngIf="order.user" class="zx-que-text-tiny-tiny">
                              <span>
                                {{ order.user | slice:0:9 }}
                              </span>
                              <span *ngIf="order.user?.length > 9">
                                ...
                              </span>
                            </span>
                          </div>
                          <!-- // username -->

                          <!-- empty -->
                          <div class="col-3 p-0 h-100"></div>
                          <!-- // empty -->

                          <!-- status -->
                          <div class="col-3 p-0 h-100 d-flex align-items-center justify-content-center">
                            <span
                              *ngIf="!(branch.plotter?.printers[0]?.printerQueue && branch.plotter?.printers[0]?.printerQueue?.length > 0) && i === 0"
                              class="zx-que-text-tiny-tiny">
                              {{ "s-screen.plotter-que.title.proccessing" | translate }}
                            </span>
                            <span
                              *ngIf="(branch.plotter?.printers[0]?.printerQueue && branch.plotter?.printers[0]?.printerQueue?.length > 0) || i !== 0"
                              class="zx-text-big">
                              <span>
                                {{ getOrderTimeEstimation(branch, order, i, false) }}
                              </span>
                              <span>
                                {{ "s-screen.minutes.short" | translate }}
                              </span>
                            </span>
                          </div>
                          <!-- status -->

                        </div>
                      </section>
                      <!-- // ----- queue orders ----- -->

                      <!-- ----- queue is Empty ----- -->
                      <section *ngIf="!(branch.plotter?.printers[0]?.printerQueue &&
                      branch.plotter?.printers[0]?.printerQueue?.length > 0) &&
                      !(branch.plotter?.printers[0]?.queue &&
                      branch.plotter?.printers[0]?.queue?.length > 0)"
                        class="w-100 flex-grow-1 d-flex flex-column justify-content-center">

                        <!-- top empty -->
                        <div class="w-100 d-flex align-items-center justify-content-center p-2">
                          <div
                            class="flex-grow-1 d-flex align-items-center justify-content-center px-3 py-2 rounded-pill zx-bg-gray-v-light-opacity">
                            <span class="zx-que-text-tiny-tiny">
                              {{ "s-screen.plotter-que.empty-title" | translate }}
                            </span>
                          </div>
                        </div>
                        <!-- // top empty -->

                        <!-- center empty -->
                        <div
                          class="w-100 flex-grow-1 d-flex flex-column align-items-center justify-content-center gap-2 p-2">
                          <img src="assets/images/que-empty-icon.svg" class="zx-que-empty-icon">
                          <b class="zx-que-text-tiny text-green">
                            {{ "s-screen.plotter-que.empty-sub" | translate }}
                          </b>
                        </div>
                        <!-- // center empty -->

                      </section>

                      <!-- for scroller QA -->
                      <!-- <section style="width: 100%; min-height: 500px; background-color: blue;"></section> -->

                      <div id="endOfContent" style="min-height: 10px;" class="w-100"></div>

                      <!-- // ----- queue is Empty ----- -->
                    </div>
                  </div>
                  <!-- // == QUEUE content == -->

                  <!-- QUEUE footer -->
                  <div *ngIf="!(!(branch.plotter?.printers[0]?.printerQueue &&
                            branch.plotter?.printers[0]?.printerQueue?.length > 0) &&
                            !(branch.plotter?.printers[0]?.queue &&
                            branch.plotter?.printers[0]?.queue?.length > 0))"
                    class="zx-que-que-footer-con d-flex justify-content-end">

                    <div class="d-flex align-items-center px-4 py-1 gap-2">
                      <img src="assets/images/printing-que-list-icon.svg" class="zx-que-tiny-icon">
                      <span>
                        <span>
                          {{ getTotalNumOfOrders(branch) }}
                        </span>
                        <span>
                          {{ "s-screen.total-orders" | translate }}
                        </span>
                      </span>
                      <span></span>
                      <img src="assets/images/printing-que-time-icon.svg" class="zx-que-tiny-icon">
                      <span>
                        <span>
                          {{ getTotalTimeEstimation(branch) }}
                        </span>
                        <span>
                          {{ "s-screen.total-minutes" | translate }}
                        </span>
                      </span>
                    </div>

                  </div>
                  <!-- // QUEUE footer -->

                </article>
                <!-- -=-=- STATUS: OK! -=-=- -->

              </div>
              <!-- // ---------==================--------- QUE AREA - [plotter] ---------==================--------- -->

              <!-- ---------- PLACE ----------  -->
              <div class="zx-que-place-con" [class.zx-que-place-con-dubble-branch]="selectedBranches.length > 1">
                <article>
                  <div class="row w-100 d-flex p-0 m-0">
                    <div class="col-5 p-0 m-0 d-flex align-items-center">
                      <div class="zx-icon-con" [class.zx-icon-con-dubble-branch]="selectedBranches.length > 1">
                        <img [src]="'assets/images/branches/' + branch.name + '.png'"
                          class="w-100 h-100 object-fit-cover">
                      </div>
                      <div class="d-flex flex-column gap-2 zx-text-white">
                        <b class="zx-que-text-medium">
                          {{ "choose-branch.naming." + printingService + "." + branch.name | translate }}
                        </b>
                        <span class="zx-que-text-tiny-tiny">
                          {{ "choose-branch.city." + branch.name | translate }}
                        </span>
                      </div>
                    </div>
                    <div class="col-7 p-0 m-0 d-flex align-items-center zx-text-white">
                      <div class="zx-icon-con" [class.zx-icon-con-dubble-branch]="selectedBranches.length > 1">
                        <img [src]="'assets/images/' + printingService + '-icon.svg'"
                          class="w-100 h-100 object-fit-cover">
                      </div>
                      <div class="d-flex flex-column gap-2">
                        <b class="zx-que-text-medium">
                          <span>
                            {{ "s-screen.title-sub.printer" | translate }}
                          </span>
                          <span>
                            #{{ getPrinterNumber(branch) }}
                          </span>
                        </b>

                        <!-- [plotter] branches -->
                        <section class="d-flex flex-column" *ngIf="printingService === 'plotter'">
                          <span class="zx-que-text-tiny-tiny">
                            <span>
                              {{ "paper-type.title" | translate }}
                            </span>
                            <span> - </span>
                            <span
                              *ngIf="branch.plotter?.printers[0]?.inputBins && branch.plotter.printers[0].inputBins.length > 1"
                              class="zx-que-text-tiny-tiny">
                              <span *ngFor="let paper of branch.plotter.printers[0].inputBins; let i = index"
                                [class.d-none]="i > 1">
                                <span>
                                  {{ "paper-type.name-short." + paper.paperType.paperType | translate }}
                                </span>
                                <span *ngIf="(branch.plotter.printers[0].inputBins.length > 1 && i === 0) ||
                                             (branch.plotter.printers[0].inputBins.length > 2 && i === i)">, </span>
                              </span>
                            </span>
                          </span>
                          <span
                            *ngIf="branch.plotter?.printers[0]?.inputBins && branch.plotter.printers[0].inputBins.length > 1"
                            class="zx-que-text-tiny-tiny">
                            <span *ngFor="let paper of branch.plotter.printers[0].inputBins; let i = index"
                              [class.d-none]="i < 2">
                              <span>
                                {{ "paper-type.name-short." + paper.paperType.paperType | translate }}
                              </span>
                              <span *ngIf="branch.plotter.printers[0].inputBins.length > i + 1">, </span>
                            </span>
                          </span>
                        </section>
                        <!-- // [plotter] branches -->

                        <!-- [express] branches -->
                        <section class="d-flex flex-column" *ngIf="printingService === 'express'">
                          <span class="zx-que-text-tiny-tiny">
                            <span>
                              {{ "paper-type.title" | translate }}
                            </span>
                            <span> - </span>
                            <span
                              *ngIf="branch.express.consumables?.papers && branch.express.consumables.papers.length > 0"
                              class="zx-que-text-tiny-tiny">
                              <span *ngFor="let paper of branch.express.consumables.papers; let i = index">
                                <span style="white-space: nowrap;">
                                  {{ "paper-type.name-short." + paper.serial_name | translate }}
                                </span>
                                <span *ngIf="branch.express.consumables.papers.length > i + 1">, </span>
                              </span>
                            </span>

                          </span>

                        </section>
                        <!-- // [express] branches -->

                      </div>
                    </div>
                  </div>
                </article>
              </div>
              <!-- // ---------- PLACE ----------  -->

            </div>
            <!-- // ================== new order ================== -->

          </div>
        </article>
      </div>
    </div>
    <article class="w-100 vh-100 position-absolute bottom-0 overflow-hidden">
      <video #videoPlayer class="object-fit-cover h-100 w-100 position-absolute zx-z-index-1" muted autoplay loop
        playsinline (canplay)="playVideoIfExists()">
        <source src="assets/videos/que-video.mp4" type="video/mp4">
      </video>
    </article>

  </div>
  <!-- ============== PRINTING QUEUE ============== -->

</div>